class UserContext {
    static key = 'UserContext';

    static get() {
        try {
            return JSON.parse(localStorage[UserContext.key]);
        } catch (err) {
            return null;
        }
    }

    static set(userContext) {
        localStorage[UserContext.key] = JSON.stringify(userContext);
    }

    static reset() {
        localStorage.removeItem(UserContext.key);
    }
}

class Token {
    static key = 'Bearer';

    static get() {
        return localStorage[Token.key];
    }

    static set(token) {
        localStorage[Token.key] = token;
    }

    static reset() {
        localStorage.removeItem(Token.key);
    }
}

const userContext = UserContext;
const token = Token;

export {
    UserContext,
    userContext,
    Token,
    token
}


// WEBPACK FOOTER //
// ./src/auth/Auth.js